var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showInfoWindow
    ? _c(
        "md-content",
        {
          class: [
            "info-tooltip md-elevation-2 md-layout map-panel",
            _vm.content.isOptimise ? "info-tooltip-height" : "",
          ],
          style: _vm.styles,
        },
        [
          _c(
            "md-card",
            {
              class: [
                "info--container",
                _vm.content.isStop ? "top-margin" : "",
                _vm.content.isOptimise ? "card-margin-top" : "",
              ],
            },
            [
              _c(
                "div",
                {
                  class:
                    _vm.content.type === "stop" ||
                    _vm.content.type === "optimisedStop"
                      ? "close-button-large"
                      : "close-button",
                  on: { click: _vm.closeInfoWindow },
                },
                [_c("md-icon", [_vm._v("close")])],
                1
              ),
              _vm.content.type === "driver"
                ? _c(
                    "md-content",
                    { staticClass: "info-detail--container" },
                    [
                      !_vm.pinnedUser
                        ? _c("md-content", { staticClass: "info-detail" }, [
                            _c("span", { staticClass: "info-heading" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.content.fullName || _vm.content.groupName
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "misc-details" },
                        [
                          _vm.content.battery && _vm.isLastLocationUpdateToday
                            ? _c(
                                "md-content",
                                {
                                  staticClass: "info-detail",
                                  attrs: { title: "Battery level" },
                                },
                                [
                                  _c(
                                    "md-icon",
                                    { staticClass: "battery-icon" },
                                    [_vm._v("battery_std")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.content.battery) + "%"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "md-content",
                            {
                              staticClass: "info-detail",
                              attrs: { title: "Speed" },
                            },
                            [
                              _vm.isLastLocationUpdateToday
                                ? _c("span", { staticClass: "time-update" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm._f("timeFormat")(
                                            _vm.content.lastLocationUpdate
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _c("span", { staticClass: "info-detail" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            _vm.content.lastLocationUpdate,
                                            _vm.DATE_TYPES.standardDateTime
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]),
                              _vm._v(
                                "\n                     \n                    "
                              ),
                              _c("md-icon", [_vm._v("speed")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(Math.round(_vm.content.speed)) +
                                    " " +
                                    _vm._s(_vm.user.speedUnits || "kph")
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.content.type === "locationHistory"
                ? _c(
                    "md-content",
                    { staticClass: "info-detail--container" },
                    [
                      _c(
                        "div",
                        { staticClass: "misc-details" },
                        [
                          _c(
                            "md-content",
                            {
                              staticClass: "info-detail",
                              attrs: { title: "Speed" },
                            },
                            [
                              _vm.isDateToday
                                ? _c("span", { staticClass: "time-update" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm._f("timeFormat")(
                                            _vm.content.lastLocationUpdate
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n                     \n                    "
                              ),
                              _c("md-icon", [_vm._v("speed")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(Math.round(_vm.content.speed)) +
                                    " " +
                                    _vm._s(_vm.user.speedUnits || "kph")
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.isDateToday
                        ? _c(
                            "md-content",
                            {
                              staticClass: "info-detail location-update",
                              attrs: { title: "Location update" },
                            },
                            [
                              _c("span", { staticClass: "info-label" }, [
                                _vm._v("Last location update"),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.content.lastLocationUpdate,
                                      _vm.DATE_TYPES.standardDateTime
                                    )
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.isAssetGroup
                        ? _c(
                            "md-content",
                            {
                              staticClass: "info-detail update-type",
                              attrs: { title: "Type of update" },
                            },
                            [
                              _c("md-icon", [_vm._v("settings")]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.content.logType)),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm.content.type === "stop"
                ? _c(
                    "div",
                    [
                      _c("info-window-stop-content", {
                        attrs: {
                          content: _vm.content,
                          "show-details-page": _vm.showDetailsPage,
                          "get-capacity-info": _vm.getCapacityInfo,
                          "has-capacity-settings": _vm.hasCapacitySettings,
                          "get-skills-info": _vm.getSkillsInfo,
                          "has-skills-settings": _vm.hasSkillsSettings,
                          "get-service-info": _vm.getServiceInfo,
                          "has-service-settings": _vm.hasServiceSettings,
                        },
                        on: {
                          handleReassignedStop: _vm.handleReassignedStop,
                          handleDeleteStop: _vm.handleDeleteStop,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.content.type === "statusHistory"
                ? _c(
                    "md-content",
                    { staticClass: "info-detail--container" },
                    [
                      _c(
                        "md-content",
                        { staticClass: "info-detail stop-address" },
                        [
                          _c("span", { staticClass: "info-heading" }, [
                            _vm._v(_vm._s(_vm.content.address)),
                          ]),
                        ]
                      ),
                      _c(
                        "md-content",
                        {
                          staticClass: "info-detail stop-ref",
                          on: { click: _vm.stopRefClicked },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.content.stopRef) +
                              "\n            "
                          ),
                        ]
                      ),
                      _c(
                        "md-content",
                        {
                          staticClass:
                            "info-detail--container stop-status--detail stop-status--change",
                        },
                        [
                          _c(
                            "span",
                            {
                              style: {
                                color: _vm.setColor(_vm.content.oldStatus),
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.content.oldStatus) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _c("md-icon", { staticClass: "arrow-icon" }, [
                            _vm._v("arrow_right_alt"),
                          ]),
                          _c(
                            "span",
                            {
                              style: {
                                color: _vm.setColor(_vm.content.newStatus),
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.content.newStatus) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "md-content",
                        {
                          staticClass: "info-detail action-date",
                          attrs: { title: "Action date" },
                        },
                        [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v("Action date"),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormat")(
                                  _vm.content.actionDate,
                                  _vm.DATE_TYPES.standardDateTime
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm.content.type === "optimisedStop"
                ? _c(
                    "div",
                    [
                      _c("info-window-optimised-stop-content", {
                        attrs: {
                          content: _vm.content,
                          "show-details-page": _vm.showDetailsPage,
                          "get-capacity-info": _vm.getCapacityInfo,
                          "has-capacity-settings": _vm.hasCapacitySettings,
                          "get-skills-info": _vm.getSkillsInfo,
                          "has-skills-settings": _vm.hasSkillsSettings,
                          "get-service-info": _vm.getServiceInfo,
                          "has-service-settings": _vm.hasServiceSettings,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.content.type === "multi-stop"
                ? _c(
                    "div",
                    [
                      _c("info-window-multi-stop-content", {
                        attrs: {
                          content: _vm.content,
                          "show-details-page": _vm.showDetailsPage,
                          "get-capacity-info": _vm.getCapacityInfo,
                          "has-capacity-settings": _vm.hasCapacitySettings,
                          "get-skills-info": _vm.getSkillsInfo,
                          "has-skills-settings": _vm.hasSkillsSettings,
                          "get-service-info": _vm.getServiceInfo,
                          "has-service-settings": _vm.hasServiceSettings,
                        },
                        on: {
                          handleReassignedStop: _vm.handleReassignedStop,
                          handleDeleteStop: _vm.handleDeleteStop,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.content.type === "geofence"
                ? _c(
                    "div",
                    [
                      _c(
                        "md-content",
                        { staticClass: "info-detail geo-fence-name" },
                        [
                          _c("b", [_vm._v(_vm._s(_vm.content.title))]),
                          _c("p", [_vm._v(_vm._s(_vm.content.notes))]),
                          _c(
                            "div",
                            { staticClass: "cta" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-button md-just-icon md-round md-primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit(
                                        "editGeofence",
                                        _vm.content.geofenceId
                                      )
                                    },
                                  },
                                },
                                [_c("md-icon", [_vm._v("edit")])],
                                1
                              ),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-button md-just-icon md-round md-primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit(
                                        "deleteGeofence",
                                        _vm.content.geofenceId
                                      )
                                    },
                                  },
                                },
                                [_c("md-icon", [_vm._v("delete")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }